"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stringLength;

var _utils = require("../utils");

var _lib = require("../lib");

function stringLength(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
      min = options.min,
      max = options.max,
      equal = options.equal;
  var label = options.label || 'Field';
  var minProp = parseInt(min, 10) || 0;
  var maxProp = parseInt(max, 10) || 0;
  var equalProp = parseInt(equal, 10) || 0;
  var defaultMsg = "".concat(label, " should be within ").concat(minProp, " to ").concat(maxProp, " letters");

  if ((0, _utils.checkValueExist)(max)) {
    (0, _utils.assertNumber)(max, 'max');
  } else {
    maxProp = value.length;
    defaultMsg = "".concat(label, " needs to be at least ").concat(minProp, " letters");
  }

  if ((0, _utils.checkValueExist)(min)) {
    (0, _utils.assertNumber)(min, 'min');
  } else {
    minProp = 0;
    defaultMsg = "".concat(label, " needs to be less than ").concat(maxProp, " letters");
  }

  if ((0, _utils.checkValueExist)(equal)) {
    (0, _utils.assertNumber)(equal, 'equal'); // set all values same as equalProp

    minProp = maxProp = equalProp;
  } else {
    equalProp = 0;
  }

  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);

  if (value.length > 0) {
    var isEqual = equalProp > 0 && value.length !== equalProp;
    var isMin = equalProp < 1 && value.length < minProp;
    var isMax = equalProp < 1 && value.length > maxProp;
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      isEqual: isEqual,
      isMin: isMin,
      isMax: isMax
    };

    if (isEqual) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " should be ").concat(equalProp, " letters"));
    } else if (isMax || isMin) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
    }
  }

  return validity;
}